import * as tslib_1 from "tslib";
import { EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TcApiError } from '@tc-core/model/it/codegen/tbx/ext/errors/tc-api-error';
import { TcHttpError } from '@tc-core/model/it/codegen/tbx/ext/errors/tc-http-error';
import { TC } from '@tc-core/util';
import { ConfigLoader, EventManager, UserJourneyManager } from '@tc-core/util/framework';
import { CommonHelper } from '@tc-core/util/helpers';
import { SpinnerService } from '@tc-core/util/ui';
import { ChipInputComponent } from '@tc/chip-input';
import { Subscription } from 'rxjs';
import { TCO } from '../../constants';
import { LeaveSearchCriteria } from '../../models/criteria/leave-search-criteria';
import { SortDirection } from '../../models/helper/sort-direction';
import { ResourceAvailabilityService } from '../../services/backend-consumers/supplier-service/resource-availability.service';
import { ChipHandlerService } from '../../services/helpers/chip-handler.service';
import { RootService } from '../../services/util/core-services/root.service';
import { ActionHandlerService } from '../../services/util/framework/action-handler-service.service';
import { DataKey, DataStoreService } from '../../services/util/framework/data-store.service';
import { DMCQueryParamsService } from '../../services/util/framework/dmc-query-params.service';
var LeaveSetupSearchCriteriaComponent = /** @class */ (function () {
    function LeaveSetupSearchCriteriaComponent(activatedRoute, configLoader, userJourneyManager, dataStoreService, actionHandlerService, em, resourceAvailabilityService, chipHandler, queryParamService, commonHelper, spinnerService, rootService) {
        this.activatedRoute = activatedRoute;
        this.configLoader = configLoader;
        this.userJourneyManager = userJourneyManager;
        this.dataStoreService = dataStoreService;
        this.actionHandlerService = actionHandlerService;
        this.em = em;
        this.resourceAvailabilityService = resourceAvailabilityService;
        this.chipHandler = chipHandler;
        this.queryParamService = queryParamService;
        this.commonHelper = commonHelper;
        this.spinnerService = spinnerService;
        this.rootService = rootService;
        this.isInsideForm = false;
        this.isSearchBarStyleNotAvailable = false;
        this.searchTrigger = new EventEmitter();
        this.searchCriteria = new EventEmitter();
        this.journey = null;
        this.isChipsInit = false;
        this.availableChips = [];
        this.persistentChipsArr = [];
        this.persistentQParams = [];
        this.persistentQParamMap = new Map();
        this.relatedChipsObsv = new Subscription();
        this.isDataLoaded = true;
        this.isTriggerSearch = true;
        this.displayChipsArr = [];
        this.isFocus = false;
        this.isChipListDisplay = false;
        this.placeHolderText = '';
        this.selectedChipsObsv = new Subscription();
        this.selectedFieldsObsv = new Subscription();
        this.chipValueUpdateSub = new Subscription();
        this.criteriaUpdateSubscription = new Subscription();
        this.deletedChipObsv = new Subscription();
        this.selectedSupplierObsv = new Subscription();
        this.selectedChips = [];
        this.chipHandlerSubject = new Subscription();
    }
    LeaveSetupSearchCriteriaComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.chipInputService = this.leaveSetupSearchChipInput.criteriaInputService;
        // set searchCriteria to null
        this.dataStoreService.set(DataKey.leaveSetupSearchCriteria, null, true);
        this.placeHolderText = 'Search Resources';
        this.tPagination = this.configLoader.configurations.get(TCO.CONF.CONF_PAGINATION_CONFIG)['LEAVE_SETUP_SEARCH'];
        //clear data store
        this.dataStoreService.set(DataKey.leaveSetupSearchResults, null, true);
        this.userJourneyManager.journey.subscribe(function (journey) {
            if (journey && JSON.stringify(journey) !== JSON.stringify({})) {
                _this.journey = journey.id;
            }
        });
        // resetting the view
        this.routerChangeSubscription = this.userJourneyManager.routeChanges.subscribe(function (e) {
            if (e) {
                _this.chipInputService.fullReset(); // fully reset chips
                _this.chipHandler.chipsArr = []; // reset chips array loaded from config
                // check journey begins from quick book
                if (!_this.isInsideForm) {
                    _this.getQueryParams();
                    _this.initSearchCriteriaChips();
                }
                console.log('displayChipsArr', _this.displayChipsArr);
                _this.resetQueryParams();
            }
        });
        this.getQueryParams();
        if (!this.isChipsInit) {
            this.initSearchCriteriaChips(); // load everything from start
        }
        this.getSearchObserver();
        this.errorObserver();
        this.selectedChipsUpdate();
        this.handleInterRelatedChips();
        this.notifyChipDelete();
        this.shortCutObserver();
    };
    LeaveSetupSearchCriteriaComponent.prototype.getQueryParams = function () {
        /* let queryParams: string[] = [];
         queryParams = this.queryParamService.getQueryParamsArray(new LeaveSearchCriteria());
 */
        /*this.leaveSetupSearchCriteria = this.rootService.loadData(queryParams, new LeaveSearchCriteria(),
            TCO.AppData.LEAVE_SETUP_SEARCH_CRITERIA
        );*/
        // get persisting query params
        if (this.leaveSetupSearchCriteria) {
            this.persistentQParams = [];
            this.persistentQParams = this.queryParamService.getNotNullQueryParamsArray(this.leaveSetupSearchCriteria);
            // remove resourceId from persistent chips when it is -1
            if (this.persistentQParams && this.persistentQParams.length > 0) {
                if (this.leaveSetupSearchCriteria.resourceId === -1) {
                    for (var i = 0; i < this.persistentQParams.length; i++) {
                        if (this.persistentQParams[i] === 'resourceId') {
                            this.persistentQParams.splice(i, 1);
                            this.leaveSetupSearchCriteria.resourceId = null;
                        }
                    }
                }
                /*else {
                 for (let i = 0; i < this.persistentQParams.length; i++) {
                 if (this.persistentQParams[i] === 'resourceTypes') {
                 this.persistentQParams.splice(i, 1);
                 this.leaveSetupSearchCriteria.resourceTypes = '';
                 }
                 }
                 }*/
            }
        }
    };
    /**
     * Search criteria chip processing
     */
    LeaveSetupSearchCriteriaComponent.prototype.initSearchCriteriaChips = function () {
        var _this = this;
        this.isChipsInit = true;
        this.chipHandler.chipsArr = [];
        // read chip config
        var criteriaChipConfigs = null;
        var chipConfigs = this.configLoader.configurations.get(TCO.CONF.CONF_LEAVE_SETUP_SEARCH_CRITERIA_CHIP);
        criteriaChipConfigs = this.commonHelper.recreateJsonObject(chipConfigs);
        if (criteriaChipConfigs && criteriaChipConfigs.chips) {
            criteriaChipConfigs.chips.forEach(function (chip) {
                chip = _this.chipHandler.preProcessChips(chip, criteriaChipConfigs.permissionKeys.keys);
            });
        }
        // this.supplierSearchCriteria = new ClientGETCriteria();
        this.chipHandler.chipsSubject.subscribe(function (data) {
            if (data && JSON.stringify(data) !== JSON.stringify([]) && data.length === criteriaChipConfigs.chips.length) {
                _this.availableChips = data; //new json object here;
                _this.chipHandler.chipsSubject.next(null);
                if (_this.chipHandlerSubject) {
                    _this.chipHandlerSubject.unsubscribe();
                }
                // set values to display chips
                _this.displayChipsArr = [];
                _this.displayChipsArr = _this.availableChips;
                _this.dataStoreService.set(DataKey.chips, _this.availableChips, true);
                _this.chipInputService.init(_this.leaveSetupSearchCriteria, _this.availableChips, false, true);
                _this.isChipsInit = true;
                // implement chip persistance
                if (_this.persistentQParams && _this.persistentQParams.length > 0) {
                    // create a queryParamMap
                    for (var i = 0; i < _this.persistentQParams.length; i++) {
                        var qParam = _this.persistentQParams[i];
                        var qParamValue = _this.leaveSetupSearchCriteria[qParam];
                        if (qParam && qParamValue) {
                            _this.persistentQParamMap.set(qParam, qParamValue);
                        }
                    }
                    _this.persistentChipsArr = [];
                    // fill persistent chips
                    _this.availableChips.forEach(function (chip) {
                        var persistChip = Object.assign({}, chip);
                        persistChip.optionParams.data = [];
                        var isPersist = false;
                        if (chip.dataParams && chip.dataParams.length > 0) {
                            chip.dataParams.forEach(function (dataParam) {
                                if (_this.persistentQParamMap.has(dataParam.paramValue)) {
                                    isPersist = true;
                                    var dataObj = {
                                        key: dataParam.paramValue,
                                        value: _this.persistentQParamMap.get(dataParam.paramValue)
                                    };
                                    persistChip.optionParams.data.push(dataObj);
                                }
                            });
                        }
                        // push persist chips to an array
                        if (isPersist) {
                            _this.persistentChipsArr.push(persistChip);
                        }
                    });
                    // persist chips
                    if (_this.persistentChipsArr && _this.persistentChipsArr.length > 0) {
                        /*const uniqueChipList = this.persistentChipsArr.filter((e, i) => {
                         return this.persistentChipsArr.findIndex((x) => {
                         return x.criteriaId === e.criteriaId;
                         }) === i;
                         });*/
                        _this.chipInputService.persistChips(_this.persistentChipsArr);
                        // trigger search when chips persisting
                        _this.isDataLoaded = false;
                        // this.isTriggerSearch = false;
                        _this.onResourceSearch(_this.leaveSetupSearchCriteria);
                    }
                }
                _this.chipInputService.criteriaUpdate.subscribe(function (_data) {
                    _this.leaveSetupSearchCriteria = _data;
                });
            }
        });
    };
    /**
     * Search resources
     * @param $event
     */
    LeaveSetupSearchCriteriaComponent.prototype.onResourceSearch = function ($event) {
        var _this = this;
        this.isDataLoaded = false;
        this.leaveSetupSearchCriteria = $event;
        this.leaveSetupSearchCriteria.sortDirection = SortDirection.ASC;
        if (this.tPagination && this.tPagination['initialFetchingPages'] &&
            this.tPagination['defaultPageResultCount']) {
            this.leaveSetupSearchCriteria.size = this.tPagination['initialFetchingPages'] *
                this.tPagination['defaultPageResultCount'];
            this.leaveSetupSearchCriteria.start = 0;
        }
        this.userJourneyManager.canProceed.next(false);
        if (JSON.stringify(this.leaveSetupSearchCriteria) !== JSON.stringify({})) {
            this.dataStoreService.set(DataKey.leaveSetupSearchCriteria, this.leaveSetupSearchCriteria, true);
            this.dataStoreService.set(DataKey.leaveSetupSearchResults, null, true);
            this.resourceAvailabilityService.searchLeaveSummaries(this.leaveSetupSearchCriteria, DataKey.leaveSetupSearchResults);
            // set criteria parameters to url
            var queryParams = [];
            queryParams = this.queryParamService.getQueryParamsArray(this.leaveSetupSearchCriteria);
            this.rootService.setDataToLocalStorage(TCO.AppData.LEAVE_SETUP_SEARCH_CRITERIA, this.leaveSetupSearchCriteria, true, queryParams, true);
            // this.spinnerService.show();
            this.isTriggerSearch = false;
            this.isDataLoaded = false;
            this.searchTrigger.emit(true);
        }
        else {
            setTimeout(function () {
                _this.isDataLoaded = true;
                _this.isTriggerSearch = true;
            }, 0);
        }
    };
    LeaveSetupSearchCriteriaComponent.prototype.onFocus = function ($event) {
        this.isFocus = $event;
    };
    LeaveSetupSearchCriteriaComponent.prototype.onCancel = function ($event) {
        console.log('cancelled');
    };
    LeaveSetupSearchCriteriaComponent.prototype.onChipListDisplay = function ($event) {
        this.dataStoreService.set(DataKey.chipListDisplay, null, true);
        this.isChipListDisplay = $event;
        this.dataStoreService.set(DataKey.chipListDisplay, this.isChipListDisplay, true);
    };
    LeaveSetupSearchCriteriaComponent.prototype.resetQueryParams = function () {
        var resourceQueryParams = [];
        resourceQueryParams = this.queryParamService.getQueryParamsArray(new LeaveSearchCriteria());
        var leaveSearchCriteria = this.rootService.loadDataFromLocalStorage([], new LeaveSearchCriteria(), TCO.AppData.LEAVE_SETUP_SEARCH_CRITERIA);
        // set criteria parameters to url
        var queryParams = [];
        queryParams = this.queryParamService.getQueryParamsArray(leaveSearchCriteria);
        this.rootService.setDataToLocalStorage(TCO.AppData.LEAVE_SETUP_SEARCH_CRITERIA, this.leaveSetupSearchCriteria, true, queryParams, true);
    };
    /**
     * observe search results to stop loading
     */
    LeaveSetupSearchCriteriaComponent.prototype.getSearchObserver = function () {
        var _this = this;
        var x = this.dataStoreService.get(DataKey.leaveSetupSearchResults).subscribe(function (data) {
            if (_this.commonHelper.dataValidity(data)) {
                setTimeout(function () {
                    _this.isDataLoaded = true;
                    _this.isTriggerSearch = true;
                }, 0);
            }
            else if (_this.commonHelper.isEmptyData(data)) {
                _this.isDataLoaded = true;
            }
            else if (data instanceof TcApiError) {
                _this.isDataLoaded = true;
            }
            else if (data instanceof TcHttpError) {
                _this.isDataLoaded = true;
            }
        }, function (error) {
            console.log(error);
        });
    };
    LeaveSetupSearchCriteriaComponent.prototype.errorObserver = function () {
        var _this = this;
        this.dataStoreService.get(DataKey.error).subscribe(function (data) {
            if (data && JSON.stringify(data) !== JSON.stringify({})) {
                setTimeout(function () {
                    _this.isDataLoaded = true;
                }, 0);
                _this.dataStoreService.set(DataKey.error, null);
            }
        });
    };
    /**
     * subscribe for chip updates to enable search
     */
    LeaveSetupSearchCriteriaComponent.prototype.selectedChipsUpdate = function () {
        var _this = this;
        this.criteriaUpdateSubscription = this.chipInputService.selectedChipsSubject.subscribe(function (selectedChips) {
            var e_1, _a;
            _this.selectedChips = selectedChips;
            if (selectedChips && JSON.stringify(selectedChips) !== JSON.stringify([])) {
                try {
                    // toggle chips when selecting BRANCH_OF_CLIENT_ID chip
                    for (var _b = tslib_1.__values(_this.selectedChips), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var selectedChip = _c.value;
                        if (selectedChip.chip.id === 'BRANCH_OF_CLIENT_ID' && selectedChip.chip.optionParams.toggleChips &&
                            selectedChip.chip.optionParams.toggleChips.length > 0) {
                            _this.deleteToggleChips(selectedChip.chip.optionParams.toggleChips);
                            _this.disableChips(selectedChip.chip.optionParams.toggleChips);
                            break;
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
        });
    };
    LeaveSetupSearchCriteriaComponent.prototype.handleInterRelatedChips = function () {
        var _this = this;
        this.relatedChipsObsv = this.chipInputService.relatedChipsSubject.subscribe(function (data) {
            var toggleChips = [];
            if (data && data.chip && JSON.stringify(data) !== JSON.stringify({})) {
                _this.modifiedChip = data.chip;
                // TODO: refine chip input service: inter related chips
                if (data.chip.type === 'CALENDAR') {
                    _this.chipHandler.handleInterRelatedChips(data.chip, data.date);
                }
                else {
                    _this.chipHandler.handleInterRelatedChips(data.chip, data.options.value[0]);
                }
                if (data.chip.optionParams.toggleChips && data.chip.optionParams.toggleChips.length > 0) {
                    toggleChips = data.chip.optionParams.toggleChips;
                    if (toggleChips && data.options && data.options.value[0].value) {
                        _this.chipInputService.selectedChipsBasedOnStateChange(toggleChips);
                    }
                    else {
                        _this.chipInputService.deleteChipsBasedOnStateChange(toggleChips);
                    }
                }
            }
        });
    };
    /**
     * subscribe for chip delete
     */
    LeaveSetupSearchCriteriaComponent.prototype.notifyChipDelete = function () {
        var _this = this;
        this.deletedChipObsv = this.chipInputService.deletedChipsSubject.subscribe(function (deletedChip) {
            if (JSON.stringify(deletedChip) !== JSON.stringify({}) && deletedChip !== null && deletedChip !== undefined) {
                if (deletedChip.id === 'CLIENT_TYPE') {
                    var deleteChips = _this.selectedChips.map(function (chip) { return chip.chip; });
                    _this.deleteSelectedChips(deleteChips);
                    _this.enableChips(_this.availableChips);
                }
                else if (deletedChip.id === 'BRANCH_OF_CLIENT_ID') {
                    if (deletedChip.optionParams.toggleChips && deletedChip.optionParams.toggleChips.length > 0) {
                        _this.enableChips(deletedChip.optionParams.toggleChips);
                    }
                }
            }
        });
    };
    LeaveSetupSearchCriteriaComponent.prototype.shortCutObserver = function () {
        var _this = this;
        this.em.addEvent(TC.CONF.CONF_EVENT_MANAGER, 'FOCUS_SEARCH_BAR').subscribe(function (e) {
            _this.isFocus = true;
        });
        this.em.addEvent(TC.CONF.CONF_EVENT_MANAGER, 'CLOSE_POPUPS').subscribe(function (e) {
            _this.isFocus = false;
        });
    };
    /**
     * Delete toggle chips if already selected
     *
     * @param toggleChips
     */
    LeaveSetupSearchCriteriaComponent.prototype.deleteToggleChips = function (toggleChips) {
        var _this = this;
        var deleteChips = [];
        toggleChips.forEach(function (toggleChip) {
            var e_2, _a;
            try {
                for (var _b = tslib_1.__values(_this.selectedChips), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var selectedChip = _c.value;
                    if (selectedChip.chip.id === toggleChip.criteriaId) {
                        deleteChips.push(selectedChip.chip);
                        break;
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_2) throw e_2.error; }
            }
        });
        this.deleteSelectedChips(deleteChips);
    };
    LeaveSetupSearchCriteriaComponent.prototype.deleteSelectedChips = function (deleteChips) {
        var _this = this;
        deleteChips.forEach(function (chip) {
            _this.chipInputService.deleteChip(chip, true);
        });
    };
    LeaveSetupSearchCriteriaComponent.prototype.enableChips = function (enableChips) {
        var _this = this;
        enableChips.forEach(function (enableChip) {
            _this.chipInputService.modifyChipsStatus(enableChip, false);
        });
    };
    LeaveSetupSearchCriteriaComponent.prototype.disableChips = function (disableChips) {
        var _this = this;
        disableChips.forEach(function (disableChip) {
            _this.chipInputService.modifyChipsStatus(disableChip, true);
        });
    };
    LeaveSetupSearchCriteriaComponent.prototype.ngOnDestroy = function () {
        this.routerChangeSubscription.unsubscribe();
        this.userJourneyManager.routeChanges.next(false);
        if (this.selectedChipsObsv) {
            this.selectedChipsObsv.unsubscribe();
        }
        if (this.selectedFieldsObsv) {
            this.selectedFieldsObsv.unsubscribe();
        }
        if (this.chipValueUpdateSub) {
            this.chipValueUpdateSub.unsubscribe();
        }
        if (this.criteriaUpdateSubscription) {
            this.criteriaUpdateSubscription.unsubscribe();
        }
        if (this.deletedChipObsv) {
            this.deletedChipObsv.unsubscribe();
        }
    };
    return LeaveSetupSearchCriteriaComponent;
}());
export { LeaveSetupSearchCriteriaComponent };
